<template>
  <a-modal
    v-model="visible"
    width="900px"
    title="明细转订单"
    :maskClosable="false"
    :destroyOnClose="true"
    :centered="true"
    @ok="onSubmit"
    @cancel="onCancel"
    :confirmLoading="confirmLoading"
  >
    <data-table ref="dataTable" :option="option"> </data-table>
  </a-modal>
</template>

<script>
import { DataTable } from "@/components/dataTable";
export default {
  name: "TransferToOrder",
  props: {},
  components: {
    DataTable
  },
  data() {
    return {
      data: [],
      confirmLoading: false,
      receivableId: "",
      receivableDetailId: "",
      columns: [
        {
          title: "单号",
          width: 100,
          dataIndex: "OrderNo" //列字段名
        },
        {
          title: "挂账日期",
          width: 100,
          dataIndex: "AccountDate"
        },
        {
          title: "状态",
          width: 80,
          dataIndex: "Status",
          customRender: text => {
            if (text) {
              return <a-badge status="success" text="已核销" />;
            } else {
              return <a-badge status="error" text="未核销" />;
            }
          }
        },
        {
          title: "姓名",
          width: 100,
          dataIndex: "Contact"
        },
        {
          title: "住店日期",
          width: 100,
          dataIndex: "CheckInDate"
        },
        {
          title: "离店日期",
          width: 100,
          dataIndex: "CheckOutDate"
        },
        {
          title: "金额",
          width: 100,
          align: "right",
          dataIndex: "Amount"
        },
        {
          title: "核销金额",
          width: 100,
          align: "right",
          dataIndex: "WriteOffAmount"
        },
        {
          title: "未核金额",
          width: 100,
          align: "right",
          dataIndex: "UnWriteOffAmount"
        },
        {
          title: "渠道订单号",
          width: 150,
          dataIndex: "ChannelOrderNo"
        },
        {
          title: "备注",
          tooltip: true,
          dataIndex: "Remark"
        }
      ],
      visible: false,
      option: {}
    };
  },
  created() {
    this.option = {
      headSearch: {
        colnum: 4,
        content: [
          {
            label: "客户",
            name: "CustomerId",
            colnum: 2,
            type: "select",
            api: "Common_GetSelect", //请求接口api
            param: { Types: "customer" }, //请求参数
            dataField: "Data.customer", //请求可选项返回的数据字段
            props: {
              showSearch: true,
              optionFilterProp: "children",
              allowClear: false
            },
            option: {
              rules: [{ required: true, message: "请选择客户！" }]
            },

            onChange: () => {
              this.$nextTick(() => {
                this.$refs.dataTable.headSearch();
              });
            }
          },
          {
            label: "订单号",
            name: "OrderNo"
          },
          {
            label: "姓名",
            name: "Contact",
            pressEnter: () => {
              this.$refs.dataTable.headSearch();
            }
          }
        ]
      },
      grid: {
        api: "RecVa_GetRePageList",
        columns: this.columns,
        autoLoad: false,
        pageChange: json => {
          const data = { ...json };
          return data;
        },
        props: {
          scroll: {
            y: "calc(100vh - 260px)",
            x: 1500
          }
        },
        onLoad: res => {
          this.$emit("loadData", res.Data.Datas);
        }
      }
    };
  },
  methods: {
    show({ receivableDetailId, receivableId, customerId }) {
      this.visible = true;
      this.receivableId = receivableId;
      this.receivableDetailId = receivableDetailId;
      this.$nextTick(() => {
        this.$refs.dataTable.$refs.headSearchForm.setData({
          CustomerId: customerId
        });
        setTimeout(() => {
          this.$refs.dataTable.headSearch();
        }, 100);
      });
    },

    onCancel() {
      this.visible = false;
    },
    onSubmit() {
      const row = this.$refs.dataTable.getSelected();
      if (!row) {
        this.$message.info("请选择一条数据");
        return false;
      }
      if (this.receivableId == row.Id) {
        this.$message.error("选择的明细已经在目标订单应收中了，请重新选择订单");
        return false;
      }
      this.confirmLoading = true;
      this.$post("ReceivableDetailTransferToOrder", {
        receivableDetailId: this.receivableDetailId,
        toReceivableId: row.Id
      })
        .then(() => {
          this.visible = false;
          this.confirmLoading = false;
          this.$message.success("转账成功");
          this.$emit("submit");
        })
        .catch(() => {
          this.confirmLoading = false;
        });
    }
  }
};
</script>
<style lang="less" scoped>
.title {
  font-size: initial;
  margin-top: 5px;
}
.cnt {
  border: 1px solid #eee;
  max-height: 250px;
  overflow: auto;
  border-top: 0;
}
.payTable {
  width: 100%;
  margin-bottom: 5px;
  tr {
    td {
      padding: 2px 1px;
      width: 10%;
    }
  }
}
@keyframes shake {
  0% {
    transform: scale(1.02);
    border-color: #f00;
  }
  25% {
    transform: scale(1.05);
    border-color: #f00;
  }
  50% {
    transform: scale(1);
    border-color: #f00;
  }
  75% {
    transform: scale(1.05);
    border-color: #f00;
  }
  100% {
    transform: scale(1);
    border-color: #d9d9d9;
  }
}
.shake /deep/ .ant-input-number {
  -webkit-animation: shake 1s;
  animation: shake 1s;
}
/deep/
  .ant-table-small
  > .ant-table-content
  > .ant-table-scroll
  > .ant-table-header
  > table
  > .ant-table-thead
  > tr
  > th,
/deep/ .ant-table-bordered .ant-table-tbody > tr > td {
  padding: 2px 3px 0 3px !important;
}
.del-icon {
  color: #f00;
  font-size: 16px;
  margin-top: 5px;
  margin-left: 5px;
  cursor: pointer;
}
</style>
